module.exports = __webpack_public_path__ + "01_very_short_grey.f240c2a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/01_very_short_grey.png
// module id = Qs9N
// module chunks = 0